import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const API = `/api`;
export const COLORS = ["#2A4B3C", "#C05C3D", "#C9A227", "#7A8B4F", "#B9A88F", "#5E7C8A", "#8C5A3C"];

export const nf = (n) => new Intl.NumberFormat("it-IT", { notation: n >= 10000 ? "compact" : "standard", maximumFractionDigits: 1 }).format(n || 0);
export const df = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }) : "-");
export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Errore";

export async function pollJob(jobId, onProgress, isCancelled = () => false) {
  for (let i = 0; i < 200; i++) {
    await new Promise((r) => setTimeout(r, 2500));
    if (isCancelled()) return null;
    const { data: job } = await axios.get(`${API}/strategy/job/${jobId}`);
    onProgress(job.chars);
    if (job.status === "error") throw new Error(job.error);
    if (job.status === "done") return job.result_id;
  }
  throw new Error("Timeout: la generazione ha impiegato troppo tempo");
}

export function useApi(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}${path}`, { params });
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => { load(); }, [load]);
  return { data, error, loading, reload: load };
}
